export function detailsInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		const detailBlocks = document.querySelectorAll( '.wp-block-details' );

		detailBlocks.forEach( ( details ) => {
			const summary = details.querySelector( 'summary' );

			if ( ! summary ) {
				return;
			}

			// CONSOLIDATED SUMMARY LISTENER (Handles Open & Coordinated Close)
			summary.addEventListener( 'click', function( event ) {
				// Stop the browser's default native toggle action.
				event.preventDefault();

				const rect = summary.getBoundingClientRect();
				// check if the click happened in the specific icon region
				const ICON_AREA_PX = 35; // little wider for easier clicking
				const iconAreaStart = rect.right - ICON_AREA_PX;
				const isClickInCloseRegion = ( event.clientX >= iconAreaStart );

				// TOGGLE LOGIC
				if ( details.open ) {
					// if block is OPEN
					if ( isClickInCloseRegion ) {
						// User clicked the icon area -> CLOSE
						details.open = false;
						// stop any other external plugin listeners on this element
						event.stopPropagation();
						event.stopImmediatePropagation();
					}
				} else {
					// if block is CLOSED
					// User clicked anywhere in the summary
					details.open = true;
				}
			} );

			// OPENING: Allow clicking anywhere in the content area to open
			details.addEventListener( 'click', function( event ) {
				// If the click happened in the content area AND it's closed
				if ( ! summary.contains( event.target ) && ! details.open ) {
					// call summary.click(), which triggers the consolidated listener above
					summary.click();
				}
			} );
		} );
	} );
}

